/* eslint-disable no-console */
// Logging Implementation via New Relic Log API

import settings from '../../config/settings';

export const LogLevels = {
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
};

export const sendLogToNewRelic = (message, level) => {
    try {
        const isLocalEnv = ENVIRONMENT === 'local';

        const {
            NEW_RELIC_LICENCE_API_KEY,
            NewRelicLogEndpointUrl,
            NewRelicApplicationName,
        } = settings;

        if (isLocalEnv || !NEW_RELIC_LICENCE_API_KEY) {
            return;
        }

        const headers = {
            'Content-Type': 'application/json',
            'Api-Key': NEW_RELIC_LICENCE_API_KEY,
        };

        const body = {
            message,
            level,
            timestamp: new Date(),
            octopusProjectName: NewRelicApplicationName,
            octopusEnvironment: ENVIRONMENT,
        };

        const requestData = {
            method: 'POST',
            headers,
            body: JSON.stringify(body),
        };

        fetch(NewRelicLogEndpointUrl, requestData)
            .catch((e) => console.error('Error happened while sending log to New Relic: ', e?.message));
    } catch (e) {
        console.error('Error happened while sending log to New Relic: ', e?.message);
    }
};
